import React from 'react';

const TvIcon = ({ size = 24 }) => (
  <svg width={size} height={size * 0.95} viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'inline-block', verticalAlign: 'baseline', marginBottom: '-2px' }}>
    {/* Antenna */}
    <line x1="24" y1="2" x2="14" y2="12" stroke="#FFB703" strokeWidth="3" strokeLinecap="round"/>
    <line x1="24" y1="2" x2="34" y2="12" stroke="#FFB703" strokeWidth="3" strokeLinecap="round"/>
    {/* TV Body */}
    <rect x="4" y="13" width="40" height="28" rx="4" ry="4" stroke="#FFB703" strokeWidth="3.5" fill="none"/>
    {/* Screen inner glow */}
    <rect x="10" y="18" width="28" height="18" rx="2" ry="2" fill="#FFB703" opacity="0.12"/>
    {/* Stand legs */}
    <line x1="16" y1="41" x2="14" y2="45" stroke="#FFB703" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="32" y1="41" x2="34" y2="45" stroke="#FFB703" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

const BoxSeatLogo = ({ size = 'md', onClick, className = '' }) => {
  const config = {
    xs: { fontSize: '1.15rem', tvSize: 16, gap: '-1px', letterSpacing: '-0.03em' },
    sm: { fontSize: '1.5rem', tvSize: 20, gap: '-2px', letterSpacing: '-0.03em' },
    md: { fontSize: '2rem', tvSize: 26, gap: '-3px', letterSpacing: '-0.03em' },
    lg: { fontSize: '2.75rem', tvSize: 36, gap: '-4px', letterSpacing: '-0.04em' },
    xl: { fontSize: '3.75rem', tvSize: 50, gap: '-6px', letterSpacing: '-0.04em' },
    hero: { fontSize: '5.5rem', tvSize: 72, gap: '-8px', letterSpacing: '-0.04em' },
  };

  const c = config[size] || config.md;

  return (
    <div
      data-testid="boxseat-logo"
      className={`inline-flex flex-col items-center leading-none select-none ${className}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      role="img"
      aria-label="Box Seat logo"
    >
      {/* BOX row */}
      <div
        className="font-heading font-black uppercase flex items-baseline"
        style={{ fontSize: c.fontSize, letterSpacing: c.letterSpacing, lineHeight: 0.95 }}
      >
        <span className="text-primary">B</span>
        <TvIcon size={c.tvSize} />
        <span className="text-primary">X</span>
      </div>
      {/* SEAT row */}
      <div
        className="font-heading font-black uppercase text-primary"
        style={{ fontSize: c.fontSize, letterSpacing: c.letterSpacing, marginTop: c.gap, lineHeight: 0.95 }}
      >
        SEAT
      </div>
    </div>
  );
};

export default BoxSeatLogo;
